const COLORES_ESTADOS = {
  Falso: "#F72D54",
  Verdadero: '#429572',
  Engañoso: "#bc503c",
  Si_pero: '#72c06a',
  Cuestionable: "#fee400",
  Bulo: "#bd5f32",
  Impreciso: "#bc503c",
  Sacado_de_contexto: "#d28921",
  Insostenible: "#f4543c",
  Sátira: "#FA00C3",
  Explicador: "#929292"
};

export function getColor(veredictoKey) {
  const Si_pero = "Si, pero";
  const Sacado_de_contexto = "Sacado de contexto";
  const En_proceso = "En proceso";

  if(veredictoKey === "Si, pero"){
    const key = Si_pero.replace(/\s+/g,"_");
    return COLORES_ESTADOS[key];
  }
  else if(veredictoKey === "Sacado de contexto"){
    const key = Sacado_de_contexto.replace(/\s+/g,"_");
    return COLORES_ESTADOS[key];
  }
  return COLORES_ESTADOS[veredictoKey];
}

const COLORES_PAIS = {
  méxico: "#106D4F",
  colombia: "#DADE1D",
  bolivia: "#238956",
  brasil: "#F8FC2C",
  uruguay: '#2C41FC',
  argentina: '#64C3C3', 
  españa: '#FC2C2C', 
  chile: '#FE0F00',
  perú: '#E04040', 
  ecuador: '#C7CB08',
  paraguay: '#5464F9',
  venezuela: '#F9FE00',
  costa_rica: '#0618B9',
  guatemala: '#3598F2',
  nicaragua: '#2C34FC',
  panama: '#E70000',
  ecuador: '#C1FF3E',
  puerto_rico: '#B40000',
};

export function getColorPais(pais) {

  const color = pais.toLowerCase();

  const puerto_rico = "Puerto Rico";
  const costa_rica = "Costa Rica";

  if(pais === "Puerto Rico"){
    const key = puerto_rico.replace(/\s+/g,"_").toLowerCase();

    return COLORES_PAIS[key];
  }
  else if(pais === "Costa Rica"){
    const key = costa_rica.replace(/\s+/g,"_").toLowerCase();
    return COLORES_PAIS[key];
  }
  
  return COLORES_PAIS[color];
}

const BANDERA_PAIS = {
  méxico: "https://flagcdn.com/16x12/mx.png",
  colombia: "https://flagcdn.com/16x12/co.png",
  bolivia: "https://flagcdn.com/16x12/bo.png",
  brasil: "https://flagcdn.com/16x12/br.png",
  uruguay: 'https://flagcdn.com/16x12/uy.png',
  españa: 'https://flagcdn.com/16x12/es.png',
  chile: 'https://flagcdn.com/16x12/cl.png',
  perú: 'https://flagcdn.com/16x12/pe.png',
  ecuador: 'https://flagcdn.com/16x12/ec.png',
  argentina: 'https://flagcdn.com/16x12/ar.png',
  costa_rica: 'https://flagcdn.com/16x12/cr.png',
  puerto_rico: 'https://flagcdn.com/16x12/pr.png',
  paraguay: 'https://flagcdn.com/16x12/py.png',
  venezuela: 'https://flagcdn.com/16x12/ve.png',
  guatemala: 'https://flagcdn.com/16x12/gt.png',
  nicaragua: 'https://flagcdn.com/16x12/ni.png',
  panama: 'https://flagcdn.com/16x12/pa.png',

};

export function getBandera(pais) {

  const puerto_rico = "Puerto Rico";
  const costa_rica = "Costa Rica";

  if(pais === "Puerto Rico"){
    const key = puerto_rico.replace(/\s+/g,"_").toLowerCase();

    return BANDERA_PAIS[key];
  }
  else if(pais === "Costa Rica"){
    const key = costa_rica.replace(/\s+/g,"_").toLowerCase();
    return BANDERA_PAIS[key];
  }
  const color = pais.toLowerCase();
  return BANDERA_PAIS[color];
}

